import { judgeAnnualInterestRange, judgeAcceptanceTime } from '@/utils/judge'
import { matchFilterCondition } from '@/utils/getSelectList'
import store from '@/store/index.js'

function filterProductDetail(productDetail) {
  if (!productDetail) return {}
  return {
    name: productDetail.name,
    bankName: productDetail.bankName,
    quotaRangeEnd: productDetail.quotaRangeEnd + '万以下',
    loanUse: productDetail.loanUse,
    termRange: `${productDetail.termRangeStart}~${productDetail.termRangeEnd}月`,
    annualInterestRange: judgeAnnualInterestRange(
      productDetail.annualInterestRangeStart,
      productDetail.annualInterestRangeEnd
    ),
    acceptanceTime: `${judgeAcceptanceTime(
      productDetail.acceptanceTimeStart,
      productDetail.acceptanceTimeEnd
    )}个工作日`,
    guaranteeMeans: productDetail.guaranteeMeansList.join('，'),
    repaymentMeans: productDetail.repaymentMeansList.join('，'),
    financingCategory: matchFilterCondition(
      productDetail.financingCategory,
      '融资类别',
      store.state.product.listCondition
    )
  }
}

export { filterProductDetail }
